/**
 * This simple type specifies the compound line type that is to be used for
 * lines with text such as underlines.
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.10.15
 */
export enum CompoundLine {
    /** Single line: one normal width */
    SINGLE = "SINGLE",

    /** Double lines of equal width */
    DOUBLE = "DOUBLE",

    /** Double lines: one thick, one thin */
    THICK_THIN = "THICK_THIN",

    /** Double lines: one thin, one thick */
    THIN_THICK = "THIN_THICK",

    /** Three lines: thin, thick, thin */
    THIN_THICK_THIN = "THIN_THICK_THIN",
}
